// e.g. "G. Brown" -> "GB"
export default function getInitials(name: string) {
  return (name[0] + name[3]).toUpperCase()
}
